import React from "react";
import {Pagination, PaginationItem, PaginationLink} from "reactstrap";

interface PrivilegeListPaginationProps {
    currentPage: number;
    perPage: number;
    totalRows: number;
    visibleCount: number;
    onPageChange: (page: number) => void;
}

const PrivilegeListPagination: React.FC<PrivilegeListPaginationProps> = ({
    currentPage,
    perPage,
    totalRows,
    visibleCount,
    onPageChange,
}) => {
    const hasPreviousPage = currentPage > 1;
    const hasNextPage = currentPage * perPage < totalRows;

    return (
        <div className='d-flex justify-content-between align-items-center mt-3'>
            <small className='text-muted'>
                Showing {visibleCount} of {totalRows}
            </small>
            <Pagination className='mb-0'>
                <PaginationItem disabled={!hasPreviousPage}>
                    <PaginationLink previous onClick={() => hasPreviousPage && onPageChange(currentPage - 1)}/>
                </PaginationItem>
                <PaginationItem disabled>
                    <PaginationLink>{currentPage}</PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={!hasNextPage}>
                    <PaginationLink next onClick={() => hasNextPage && onPageChange(currentPage + 1)}/>
                </PaginationItem>
            </Pagination>
        </div>
    );
};

export default PrivilegeListPagination;

